var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "screeningDataInfo-edit" } },
    [
      _c(
        "IForm",
        {
          ref: "formInline",
          attrs: {
            "label-width": 80,
            model: _vm.edit,
            elem: _vm.editElem,
            rules: _vm.editRule,
            submit: false,
            showMessage: true,
          },
          on: { "on-submit": _vm.toSubmit },
        },
        [
          _c(
            "div",
            { attrs: { slot: "extend" }, slot: "extend" },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "姓名", prop: "name" } },
                        [
                          _c(
                            "el-select",
                            {
                              ref: "mySelect",
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请搜索姓名",
                                clearable: "",
                                filterable: "",
                                remote: "",
                                size: "small",
                                transfer: "true",
                                "no-match-text": "无数据",
                                "no-data-text": "无数据",
                                "automatic-dropdown": true,
                                "popper-append-to-body": false,
                                "remote-method": (query) => {
                                  _vm.queryStudent(query)
                                },
                              },
                              on: {
                                "visible-change": _vm.handleArrow,
                                change: function ($event) {
                                  return _vm.selectStudent($event)
                                },
                                clear: _vm.handleClear,
                              },
                              model: {
                                value: _vm.edit.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "name", $$v)
                                },
                                expression: "edit.name",
                              },
                            },
                            _vm._l(_vm.options, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                staticStyle: { width: "100%" },
                                attrs: {
                                  label: item.name + "(" + item.idCard + ")",
                                  empty: "无数据",
                                  value: item,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "学校" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "学校",
                              disabled: _vm.disabled,
                            },
                            model: {
                              value: _vm.edit.schoolName,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "schoolName", $$v)
                              },
                              expression: "edit.schoolName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "年级" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "年级",
                              disabled: _vm.disabled,
                            },
                            model: {
                              value: _vm.edit.gradeName,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "gradeName", $$v)
                              },
                              expression: "edit.gradeName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "班级" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "班级",
                              disabled: _vm.disabled,
                            },
                            model: {
                              value: _vm.edit.classesName,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "classesName", $$v)
                              },
                              expression: "edit.classesName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "出生日期" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "出生日期",
                              disabled: _vm.disabled,
                            },
                            model: {
                              value: _vm.edit.birthday,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "birthday", $$v)
                              },
                              expression: "edit.birthday",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "证件号码" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "证件号码",
                              disabled: _vm.disabled,
                            },
                            model: {
                              value: _vm.edit.idCard,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "idCard", $$v)
                              },
                              expression: "edit.idCard",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "体检套餐", prop: "packagesId" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              on: { "on-change": _vm.changePackages },
                              model: {
                                value: _vm.edit.packagesId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "packagesId", $$v)
                                },
                                expression: "edit.packagesId",
                              },
                            },
                            _vm._l(_vm.packagesLists, function (item) {
                              return _c(
                                "Option",
                                { key: item.id, attrs: { value: item.id } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "体检报告" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { multiple: "" },
                              model: {
                                value: _vm.edit.reportTemplateIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "reportTemplateIds", $$v)
                                },
                                expression: "edit.reportTemplateIds",
                              },
                            },
                            _vm._l(_vm.reportTemplates, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "FormItem",
                [
                  _c("EditTabPanel", {
                    ref: "editTabPanel",
                    attrs: {
                      "show-tabs": ["physicalProject", "lisProject"],
                      projectIds: _vm.edit.projectIds,
                      lisProjectIds: _vm.edit.lisProjectIds,
                    },
                    on: {
                      "update:projectIds": function ($event) {
                        return _vm.$set(_vm.edit, "projectIds", $event)
                      },
                      "update:project-ids": function ($event) {
                        return _vm.$set(_vm.edit, "projectIds", $event)
                      },
                      "update:lisProjectIds": function ($event) {
                        return _vm.$set(_vm.edit, "lisProjectIds", $event)
                      },
                      "update:lis-project-ids": function ($event) {
                        return _vm.$set(_vm.edit, "lisProjectIds", $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }